export function buildUrl(
  endpoint: `/${string}`,
  service: string = '',
  version: string = '/v1',
  queryParameters?: Record<string, string>
) {
  const base = '/api';
  const params = new URLSearchParams(queryParameters);
  return (
    base +
    service +
    version +
    endpoint +
    (queryParameters ? `?${params.toString()}` : '')
  );
}
